import { styled } from 'stitches.config'

export const Title = styled('h2', {
  textAlign: 'left',
  fontSize: '$h5',
  lineHeight: '$h5',
  letterSpacing: '$h5',
  width: '100%',
  margin: 'auto',
  fontFamily: '$primary'
})

export const FaqsRoot = styled('div', {
  '& .raw-benefits-faqs': {
    maxWidth: 'none',
    '& button, div': {
      fontFamily: '$primary',
      fontSize: '$body',
      letterSpacing: '$body',
    },
    '& > div:first-child': {
      borderTop: '1px solid $accent-gray',
    },
  },
})
